import mixpanel from "mixpanel-browser";

let initialized = false;

const JOURNEY_ORIGIN = "mini-GAQ";

export function initAnalytics() {
  if (initialized) return;

  mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_TOKEN, {
    autocapture: true,
    track_pageview: true,
    persistence: "localStorage",
    record_sessions_percent: 100,
    record_heatmap_data: true,
  });

  mixpanel.register({
    journeyOrigin: JOURNEY_ORIGIN,
  });

  initialized = true;
}

export function track(event, props = {}) {
  if (!initialized) {
    initAnalytics();
  }

  mixpanel.track(event, {
    ...props,
    journeyOrigin: JOURNEY_ORIGIN,
  });
}
